export default __webpack_public_path__ + "static/media/CORBELB.1eca2965.TTF";